import { skipToken } from '@reduxjs/toolkit/query'

import { SafetyPlan, SafetyPlanStatus } from '@lyrahealth-inc/shared-app-logic/src/models/safetyPlan/SafetyPlan'

import { useGetClientSafetyPlansQuery } from './safetyPlanApi'
import { CLIENT_NEW_SAFETY_PLAN, CLIENT_SAFETY_PLAN } from '../../../common/constants/routingConstants'

export const useClientSafetyPlan = (clientId?: string | null) => {
  const { data, isSuccess, isError, refetch } = useGetClientSafetyPlansQuery(
    clientId ? { patientId: clientId } : skipToken,
  )
  const plan: SafetyPlan | undefined = data?.find(({ status }) => status !== SafetyPlanStatus.EXPIRED)
  return { data: plan, isSuccess, isError, refetch }
}

export const getSafetyPlanRoute = (plan?: SafetyPlan) =>
  plan?.status === SafetyPlanStatus.ACTIVE ? CLIENT_SAFETY_PLAN.route : CLIENT_NEW_SAFETY_PLAN.route
